import { BillingSubscriptionCategory, BillingSubscriptionCustomCategories, isUnknownEnumValue, } from '@lucidlink/dto/validation';
const getCategory = (args) => {
    if (!args) {
        return undefined;
    }
    if ('category' in args) {
        return args.category;
    }
    return args.subscription?.category;
};
export const checkIsStarter = (args) => getCategory(args) === BillingSubscriptionCategory.STARTER;
export const checkIsBusiness = (args) => getCategory(args) === BillingSubscriptionCategory.BUSINESS;
export const checkIsPlgLegacy = (args) => getCategory(args) === BillingSubscriptionCategory.CUSTOM_PLG_LEGACY;
export const checkIsEnterprise = (args) => {
    if (!args) {
        return false;
    }
    if ('billingUnitId' in args && Boolean(args.billingUnitId)) {
        return true;
    }
    const category = getCategory(args);
    return (category != undefined &&
        !isUnknownEnumValue(category) &&
        BillingSubscriptionCustomCategories.includes(category));
};
export function getWorkspaceBillingStatus(workspaceBillingData) {
    const hasAwsMarketplaceContract = Boolean(workspaceBillingData?.awsMarketplaceContractId);
    const hasEnterprisePlan = checkIsEnterprise(workspaceBillingData);
    return {
        hasEnterprisePlan,
        hasAwsMarketplaceContract,
    };
}
